<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('button.add') }}</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('科目')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('button.delete') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('tip.selected') }} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{ $t('tip.term') }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('button.edit') }}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('button.more') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)"> {{ $t('button.details') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('button.delete') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-cap-subject-item-modal ref="modalForm" @ok="modalFormOk"></efs-cap-subject-item-modal>
  </a-card>
</template>

<script>

    import '@/assets/less/TableExpand.less'
    import { mixinDevice } from '@/utils/mixin'
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import EfsCapSubjectItemModal from './modules/EfsCapSubjectItemModal'

    export default {
        name: 'EfsCapSubjectItemList',
        mixins:[JeecgListMixin, mixinDevice],
        components: {
            EfsCapSubjectItemModal
        },
        data () {
            return {
                description: '科目管理页面',
                // 表头
                columns: [
                    {
                        title: '#',
                        dataIndex: '',
                        key:'rowIndex',
                        width:60,
                        align:"center",
                        customRender:function (t,r,index) {
                            return parseInt(index)+1;
                        }
                    },
                    {
                        title:'科目编号',
                        align:"center",
                        dataIndex: 'code'
                    },
                    {
                        title:'科目名称',
                        align:"center",
                        dataIndex: 'name'
                    },
                    {
                        title:'后台备注',
                        align:"center",
                        dataIndex: 'notes'
                    },
                    {
                      slotName: 'tableHeader.operation',
                        dataIndex: 'action',
                        align:"center",
                        fixed:"right",
                        width:147,
                        scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
                    }
                ],
                url: {
                    list: "/basicItem/efsCapSubjectItem/list",
                    delete: "/basicItem/efsCapSubjectItem/delete",
                    deleteBatch: "/basicItem/efsCapSubjectItem/deleteBatch",
                    exportXlsUrl: "/basicItem/efsCapSubjectItem/exportXls",
                    importExcelUrl: "basicItem/efsCapSubjectItem/importExcel",

                },
                dictOptions:{},
            }
        },
        created() {
        },
        computed: {
            importExcelUrl: function(){
                return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
            },
        },
        methods: {
            initDictConfig(){
            }
        }
    }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>